import type { AppUserSliceState } from "@/store/reducers/appUser";

/**
 * Resolves the profile (chosenName, firstName) for a patient by external ID from
 * app user state. Use for current user (appUser.externalId) or a linked patient.
 * Use with getPreferredFirstName from utils/user.util for display names.
 */
const getProfileForPatientExternalId = ({
  appUser,
  patientExternalId,
}: {
  appUser: Pick<
    AppUserSliceState,
    "chosenName" | "externalId" | "firstName" | "linkedPatients"
  >;
  patientExternalId: string;
}): { chosenName?: string; firstName: string } | undefined => {
  if (appUser.externalId === patientExternalId) {
    return {
      chosenName: appUser.chosenName,
      firstName: appUser.firstName,
    };
  }
  const linked = appUser.linkedPatients?.find(
    (p) => p.externalId === patientExternalId,
  );
  return linked
    ? { chosenName: linked.chosenName, firstName: linked.firstName }
    : undefined;
};

export { getProfileForPatientExternalId };
